<section class="mod-page" data-module="scheduling">
  <header class="page-header">
    <div>
      <p class="eyebrow">Hearing scheduling · Peshkar</p>
      <h1>Hearing scheduling</h1>
    </div>
  </header>

  @if (message()) {
    <p class="toast">{{ message() }}</p>
  }

  <div class="grid-2">
    <section class="panel">
      <h2 style="font-size: 1rem; margin-bottom: 0.65rem">Cases ready to schedule</h2>
      <ul style="list-style:none;margin:0;padding:0;display:grid;gap:0.45rem">
        @for (p of pendingHearings(); track p.id) {
          <li>
            <button
              type="button"
              class="btn"
              style="width:100%;text-align:left"
              [class.primary]="caseNo === p.id || caseNo == p.id"
              (click)="pickPending(p.id, p.subject)"
            >
              <strong>{{ p.id }}</strong> · {{ p.subject }}
              @if (p.status === 'scheduled') {
                <span class="pill" style="margin-left:0.35rem">Add sitting</span>
              }
            </button>
          </li>
        } @empty {
          <li class="muted">
            No cases waiting. DM must open <strong>Resolution Dashboard</strong> and click
            <strong>Need Hearing → Peshkar</strong> (or <strong>Need Another Hearing</strong> after a sitting).
          </li>
        }
      </ul>
    </section>

    <aside style="display: grid; gap: 0.9rem">
      <section class="panel">
        <h2 style="font-size: 1rem; margin-bottom: 0.65rem">Role availability</h2>
        <ul style="list-style: none; margin: 0; padding: 0; display: grid; gap: 0.55rem">
          @for (o of availableOfficers(); track o.id) {
            <li style="display: flex; flex-wrap: wrap; justify-content: space-between; gap: 0.5rem">
              <span>{{ o.name }} · {{ o.department }}</span>
              <span class="pill">{{ o.availability }}</span>
            </li>
          }
        </ul>
      </section>

      <section class="panel">
        <h2 style="font-size: 1rem; margin-bottom: 0.65rem">Selected Hearing</h2>
        <div class="toolbar" style="padding: 0; border: 0; box-shadow: none; background: transparent">
          <label>
            Date
            <input
              class="field"
              type="date"
              [(ngModel)]="hearingDate"
              [min]="minHearingDate"
              required
            />
          </label>
          <label>
            Time
            <input class="field" type="time" [(ngModel)]="hearingTime" required />
          </label>
          <label>Venue<input class="field" [(ngModel)]="venue" /></label>
          <label>Officer<input class="field" [(ngModel)]="officer" placeholder="Officer id (optional)" /></label>
          <label>
            Case No
            <select
              class="field"
              [ngModel]="caseNo"
              (ngModelChange)="onCaseChange($event)"
              [disabled]="!pendingHearings().length"
            >
              @if (!pendingHearings().length) {
                <option value="">No DM hearing requests</option>
              }
              @for (p of pendingHearings(); track p.id) {
                <option [ngValue]="p.id">{{ p.id }} — {{ p.subject }}</option>
              }
            </select>
          </label>
          <label style="flex: 1.4">Subject<input class="field" [ngModel]="subject" readonly /></label>
        </div>
        <div class="btn-row" style="margin-top: 0.75rem">
          @if (canMutate()) {
            <button type="button" class="btn primary" [disabled]="!caseNo" (click)="schedule()">Schedule</button>
            <button type="button" class="btn" [disabled]="!selectedHearing()" (click)="reschedule()">Reschedule</button>
            <button type="button" class="btn" [disabled]="!selectedHearing()" (click)="cancel()">Cancel</button>
          } @else {
            <p class="muted">View only — scheduling requires peshkar / admin.</p>
          }
        </div>
        @if (!caseNo && !selectedHearing()) {
          <p class="muted" style="margin-top: 0.55rem">
            Schedule needs a Case No from DM. Reschedule / Cancel: click a row in the table below.
          </p>
        }
      </section>
    </aside>
  </div>

  <div class="table-wrap">
    <table>
      <thead>
        <tr>
          <th>Case</th>
          <th>Subject</th>
          <th>When</th>
          <th>Venue</th>
          <th>Role</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        @for (h of hearings(); track h.id) {
          <tr
            style="cursor: pointer"
            [style.background]="selectedHearingId() == h.id ? 'rgba(196, 98, 45, 0.12)' : null"
            (click)="selectHearing(h)"
          >
            <td>{{ h.caseNo }}</td>
            <td>{{ h.subject }}</td>
            <td>{{ h.scheduledAt | date: 'd MMM y, h:mm a' }}</td>
            <td>{{ h.venue }}</td>
            <td>{{ h.officers }}</td>
            <td><span class="pill">{{ h.status }}</span></td>
          </tr>
        } @empty {
          <tr>
            <td colspan="6" class="muted" style="text-align:center;padding:1.25rem">No hearings scheduled yet.</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</section>
